import { render, staticRenderFns } from "./NHRAdd.vue?vue&type=template&id=2a46cb0c&"
import script from "./NHRAdd.vue?vue&type=script&lang=js&"
export * from "./NHRAdd.vue?vue&type=script&lang=js&"
import style0 from "./NHRAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports